import { Video } from "../pages/content/types";
import http from "../utils/http";
import { ISubscription } from "./SubscriptionServices";

export interface IMemberStats {
  total: number;
  totalGymMembers: number;
  totalOnlineMembers: number;
  totalSubscribers: number;
  totalVisitors: number;
}
export interface IPurchaseState {
  totalSold: number;
  totalAmount: number;
  gymMemberships: number;
  onlineMemberships: number;
  otherPrograms: number;
}

export interface IMostViewedVideos {
  mostViewed: Video[];
}
export interface IDietRequestState {
  addressed: number;
  open: number;
  total: number;
}

interface ISubscriptionFace {
  subscriptionDetails: ISubscription;
  subCount: number;
}
export interface ISoldProgramStates {
  programs: ISubscriptionFace[];
}
const GetMemberStates = async ({
  timeFrame,
}: {
  timeFrame: string;
}): Promise<IMemberStats> => {
  const urlPath = `/admin/dashboard-stats/member?timeFrame=${timeFrame}`;

  const result = await http.get({ path: urlPath });

  if (result.status == 200) {
    return result.data as IMemberStats;
  } else {
    throw new Error(`Error While Fetching States: ${result.statusText}`);
  }
};

const GetPurchaseStates = async ({
  timeFrame,
}: {
  timeFrame: string;
}): Promise<IPurchaseState> => {
  const urlPath = `/admin/dashboard-stats/purchase?timeFrame=${timeFrame}`;
  const result = await http.get({ path: urlPath });
  if (result.status == 200) {
    return result.data as IPurchaseState;
  } else {
    throw new Error(`Error While Fetching States: ${result.statusText}`);
  }
};

const GetDietRequestStates = async ({
  timeFrame,
}: {
  timeFrame: string;
}): Promise<IDietRequestState> => {
  const urlPath = `/admin/dashboard-stats/consultation-requests?timeFrame=${timeFrame}`;
  const result = await http.get({ path: urlPath });

  console.log("Result", result.data);
  if (result.status == 200) {
    return result.data as IDietRequestState;
  } else {
    throw new Error(`Error While Fetching States: ${result.statusText}`);
  }
};

const GetMostViewVideos = async ({
  timeFrame,
}: {
  timeFrame: string;
}): Promise<Video[]> => {
  const urlPath = `/admin/dashboard-stats/top-views?timeFrame=${timeFrame}`;
  const result = await http.get({ path: urlPath });

  if (result.status == 200 && result?.data?.mostViewed.length) {
    return result.data.mostViewed as Video[];
  } else {
    throw new Error(`Error While Fetching States: ${result.statusText}`);
  }
};

const GetMostSoldProgram = async ({
  timeFrame,
}: {
  timeFrame: string;
}): Promise<ISoldProgramStates> => {
  const urlPath = `/admin/dashboard-stats/most-selling-programs?timeFrame=${timeFrame}`;
  const result = await http.get({ path: urlPath });

  console.log("RESTLSTATE", result);
  if (result.status == 200) {
    return result.data as ISoldProgramStates;
  } else {
    throw new Error(`Error While Fetching States: ${result.statusText}`);
  }
};

export {
  GetMemberStates,
  GetPurchaseStates,
  GetDietRequestStates,
  GetMostViewVideos,
  GetMostSoldProgram,
};
